import { api } from '@http/constants';
import fetchWrapper from '@/http/fetchWrapper';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { userAtom } from '@/global-store';

export interface OrganisationSettingsResponse {
  restrictUserAccess: boolean;
  restrictUserAccessSupport: boolean;
  showGovernance: boolean;
  ticketsLimit: number;
}

export function useFetchOrgSettings() {
  const user = useAtomValue(userAtom);

  return useQuery({
    queryKey: [api.orgSettings],
    queryFn: () =>
      fetchWrapper.get<OrganisationSettingsResponse>(api.orgSettings),
    enabled: Boolean(user),
  });
}
